import type { MaterialFormulaFlag } from "../types";

export type { MaterialFormulaFlag };

export function buildEditsByCategory(materialsByGroup: any): Record<string, string[]> {
    const byCategory: Record<string, string[]> = {};
    for (const rows of Object.values(materialsByGroup || {}) as any[]) {
        for (const row of rows) {
            const keys =
                row.mode === "single"
                    ? [row.id]
                    : row.lines.map((line: any) => line.lineId);
            if (!byCategory[row.category]) byCategory[row.category] = [];
            byCategory[row.category].push(...keys);
        }
    }
    return byCategory;
}

export function findFormulaProduct(
    products: any[],
    categoryId: string,
    selectedProductId: string,
) {
    return products.find(
        (p) =>
            p.CategoryId === categoryId &&
            p.ManufacturerProductId &&
            (selectedProductId === p.ManufacturerProductId ||
                selectedProductId.startsWith(`${p.ManufacturerProductId}-`)),
    );
}

export function resolveFormulaExpression(
    category: any,
    product: any,
): string | null {
    return product?.CustomFormula ?? category?.DefaultFormula ?? null;
}

export function categoryHasFormula(category: any, products: any[]): boolean {
    if (!category) return false;
    if (category.DefaultFormula) return true;
    return products.some(
        (p) => p.CategoryId === category.Id && p.CustomFormula,
    );
}

export function buildMaterialFormulaFlags(
    formulas: any,
    materialsByGroup: any,
    materialsEdits: any,
): Record<string, MaterialFormulaFlag> {
    const flags: Record<string, MaterialFormulaFlag> = {};
    const categoryByName = new Map(
        (formulas?.Categories || []).map((c: any) => [c.Name, c]),
    );
    const products: any[] = formulas?.Products || [];

    for (const rows of Object.values(materialsByGroup || {}) as any[]) {
        for (const row of rows) {
            const category: any = categoryByName.get(row.category);
            const hasFormula = categoryHasFormula(category, products);

            let formulaActive = false;
            if (category) {
                const editKeys =
                    row.mode === "single"
                        ? [row.id]
                        : row.lines.map((line: any) => line.lineId);
                let selectedProductId: string | null = null;
                for (const editKey of editKeys) {
                    selectedProductId =
                        materialsEdits?.[editKey]?.selectedProductId ?? null;
                    if (selectedProductId) break;
                }
                if (selectedProductId) {
                    const product = findFormulaProduct(
                        products,
                        category.Id,
                        selectedProductId,
                    );
                    formulaActive = !!resolveFormulaExpression(category, product);
                }
            }

            const editKeys =
                row.mode === "single"
                    ? [row.id]
                    : row.lines.map((line: any) => line.lineId);
            for (const editKey of editKeys) {
                flags[editKey] = { hasFormula, formulaActive };
            }
        }
    }

    return flags;
}
